/** Runtime CSS injected into the modal (needed for Shadow DOM + host-page isolation). */
export function getInjectedCss(options: {
  buttonHoverColor: string
  buttonHoverTextColor: string
}): string {
  const { buttonHoverColor, buttonHoverTextColor } = options

  return `
    .sr-only {
      position: absolute !important;
      width: 1px !important;
      height: 1px !important;
      padding: 0 !important;
      margin: -1px !important;
      overflow: hidden !important;
      clip: rect(0, 0, 0, 0) !important;
      white-space: nowrap !important;
      border: 0 !important;
    }
    .form-popup-input:focus {
      border-color: #111111 !important;
      box-shadow: 0 0 0 1px #111111 !important;
    }
    .form-popup-input::placeholder {
      color: #9a9a9a !important;
      font-family: inherit !important;
    }
    #form-popup-recaptcha a {
      color: inherit !important;
      text-decoration: underline !important;
    }
    #form-popup-close:hover {
      background-color: #bdbdbd !important;
    }
    #form-popup-submit:hover:not(:disabled),
    #form-popup-confirmation-button:hover {
      background-color: ${buttonHoverColor} !important;
      color: ${buttonHoverTextColor} !important;
    }
    #form-popup-submit:disabled {
      opacity: 0.65 !important;
      cursor: wait !important;
    }
    @media screen and (max-width: 480px) {
      #form-popup-card {
        padding: 2.5rem 1.25rem 1.25rem !important;
      }
      #form-popup-form-title {
        font-size: 24px !important;
      }
      #form-popup-confirmation-title {
        font-size: 22px !important;
      }
    }
  `
}
